module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_newyear-08abb52d679ae6f853df4d1c9dc2b04a.jpg";